import React, { useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { addOrUpdateDashboardAsync } from "./dashboardSlice";
import { ShowToast } from "../../common/Toastr";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { getValueFromResource } from "../../common/timeLiveFunction";

interface Props {
    onClose: () => void;
    template: any;
    accountDashboardData?: any;
}

const AddDashboardModal = ({ onClose, template, accountDashboardData }: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isUpdateMode = accountDashboardData && Object.entries(accountDashboardData).length > 0;
    const [dashboardName, setDashboardName] = useState(isUpdateMode ? accountDashboardData.DashboardName : "");
    const [isDefault, setIsDefault] = useState<boolean>(isUpdateMode ? !!accountDashboardData.IsDefault : false);
    const [isFavourite, setIsFavourite] = useState<boolean>(isUpdateMode ? !!accountDashboardData.IsFavourite : false);

    const handleAddDashboard = () => {
        if (isUpdateMode && accountDashboardData?.IsDefault && !isDefault) {
            ShowToast("Warning", "atleast one dashboard must be default.", "warning", "toast-top-right");
            return;
        }
        const dashboardData = {
            DashboardName: dashboardName,
            SystemDashboardTemplateId: template?.SystemDashboardTemplateId,
            AccountEmployeeDashboardsId: isUpdateMode ? accountDashboardData.AccountEmployeeDashboardsId : null,
            IsDefault: isDefault, IsFavourite: isFavourite
            // ...(isUpdateMode && { IsDefault: isDefault, IsFavourite: isFavourite }),
        };
        dispatch(addOrUpdateDashboardAsync(dashboardData))
            .unwrap()
            .then((res) => {
                if (res?.StatusCode === '200') {
                    ShowToast("Success", res?.ResponseMessage, "success", "toast-top-right");
                    navigate("/dashboardSummary");
                } else {
                    ShowToast("Warning", res?.ResponseMessage, "warning", "toast-top-right");
                }
            })
            .catch((err) => {
                ShowToast("error", err, "error", "toast-top-right");
            });

        setDashboardName("");
        onClose();
    };

    return (
        <div className="modal drawer-overlay" style={{ display: 'block' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                        <h5 className="modal-title mainHeading">
                            {isUpdateMode ? "Update" : "Add"} {template?.title}
                        </h5>

                        <div className="btn btn-icon btn-sm btn-active-secondary ms-2" onClick={onClose}>
                            ✕
                        </div>
                    </div>

                    <div className="modal-body">
                        <label className="fs-7 fw-normal mb-2">
                            {/* Dashboard Name */}
                            {getValueFromResource("Dashboard Name", dispatch, t)}
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={dashboardName}
                            onChange={(e) => setDashboardName(e.target.value)}
                            placeholder="Enter Dashboard Name"
                        />
                        {/* {isUpdateMode && ( */}
                        <div className="d-flex gap-5 mt-4">
                            <div className="d-flex align-items-center">
                                <label className="fs-7 fw-normal mb-0 mt-1" htmlFor="toggleDefault">
                                    {/* Default */}
                                    {getValueFromResource("Default", dispatch, t)}
                                </label>
                                <div className="form-check form-switch mb-0 ms-2">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toggleDefault"
                                        checked={isDefault}
                                        onChange={(e) => setIsDefault(e.target.checked)}
                                        style={{ width: "2.5em", height: "1.25em", cursor: "pointer" }}
                                    />
                                </div>
                            </div>

                            <div className="d-flex align-items-center">
                                <label className="fs-7 fw-normal mb-0 mt-1" htmlFor="toggleFavourite">
                                    {/* Favourite */}
                                    {getValueFromResource("Favourite", dispatch, t)}
                                </label>
                                <div className="form-check form-switch mb-0 ms-2">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toggleFavourite"
                                        checked={isFavourite}
                                        onChange={(e) => setIsFavourite(e.target.checked)}
                                        style={{ width: "2.5em", height: "1.25em", cursor: "pointer" }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* )} */}
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary btn-sm" onClick={onClose}>
                            {/* Close */}
                            {getValueFromResource("Close", dispatch, t)}
                        </button>

                        <button
                            className="btn btn-primary btn-sm"
                            onClick={handleAddDashboard}
                            disabled={!dashboardName}
                        >
                            {/* Add */}
                            {getValueFromResource("Add", dispatch, t)}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AddDashboardModal;